export function getServiceCategoryHeaderOffset(
  headers: Pick<DOMRect, 'top' | 'bottom'>[],
) {
  let offset = 0;

  // Only include overlays connected to the viewport's top edge. A fixed
  // bottom bar also has a numeric computed `top`, so CSS insets cannot
  // distinguish it from a header.
  for (const header of [...headers].sort((a, b) => a.top - b.top)) {
    if (header.top > offset + 1) break;
    offset = Math.max(offset, header.bottom);
  }

  return offset;
}
